import React, { useEffect, useState } from "react";

const config = {
  staging: {
    RABBIT_URL: "wss://mq-staging.riders.ai/ws",
    RABBITMQ_READ_USER: "ridersui",
    RABBITMQ_READ_PASSWORD: "ridersui",
  },
};

const RabbitMQSender = () => {
  const [path, setPath] = useState("/amq/queue/events-session-123");
  const [message, setMessage] = useState("Test Message");
  const [status, setStatus] = useState("");

  const sendMessage = () => {
    const url = config.staging.RABBIT_URL;
    const ws = new WebSocket(url);

    ws.onopen = () => {
      console.log("Connected to RabbitMQ WebSocket");
      const auth = {
        type: "connect",
        username: config.staging.RABBITMQ_READ_USER,
        password: config.staging.RABBITMQ_READ_PASSWORD,
      };
      ws.send(JSON.stringify(auth));

      setTimeout(() => {
        const payload = {
          type: "send",
          routing_key: path,
          body: message,
        };
        ws.send(JSON.stringify(payload));
        setStatus("Message Sent!");
        ws.close();
      }, 500);
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error", error);
      setStatus("Connection Error");
    };
  };

  useEffect(() => {
    window.document.getElementById("loading")?.remove();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>RabbitMQ Message Sender</h2>
      <input
        type="text"
        value={path}
        onChange={(e) => setPath(e.target.value)}
        placeholder="Enter queue path"
        style={{ width: "100%", marginBottom: 10 }}
      />
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Enter message"
        style={{ width: "100%", marginBottom: 10 }}
      />
      <button onClick={sendMessage}>Send Message</button>
      <p>{status}</p>
    </div>
  );
};

export default RabbitMQSender;
